var React = require('react');

function SlashIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"slash-icon","fillRule":"evenodd","clipRule":"evenodd","d":"M14.0462 15.7128C12.9037 16.5235 11.5075 17 10 17C6.13401 17 3 13.866 3 10C3 8.4925 3.47653 7.09631 4.28717 5.95383L14.0462 15.7128ZM16.0681 13.4921L6.5079 3.93191C7.53572 3.33914 8.72826 3 10 3C13.866 3 17 6.13401 17 10C17 11.2717 16.6609 12.4643 16.0681 13.4921ZM20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10Z","fill":"white"}));
}

SlashIcon.defaultProps = {"aria-hidden":"1","width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = SlashIcon;

SlashIcon.default = SlashIcon;
